import { render, staticRenderFns } from "./addTeam.vue?vue&type=template&id=44926e2f&lang=html&"
import script from "./addTeam.vue?vue&type=script&lang=ts&"
export * from "./addTeam.vue?vue&type=script&lang=ts&"
import style0 from "./addTeam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports